import { action, observable } from "mobx";

interface CachedTranslation {
  use: boolean;
  value: string;
}

class CacheStore {
  @observable cachedImages: { [key: string]: Blob } = {};
  @observable cachedTranslations: { [key: string]: CachedTranslation } = {};

  @action
  setCachedImage(id: string, img: Blob) {
    this.cachedImages[id] = img;
  }

  @action
  setTranslation(id: string, value: CachedTranslation) {
    this.cachedTranslations[id] = value;
  }
}

export const cacheStore = new CacheStore();
